/* CCL-670: collapse the .reco-space-reserve placeholder when the ConvertCart reco
   widget never loads (theme editor, ConvertCart disabled/down) so it doesn't leave
   a blank gap. No-op when the widget is present. */
(function () {
  var RECO_SELECTOR = ':scope > [id^="reco-"]';
  var TIMEOUT_MS = 4000;

  function manage(slot) {
    var section = slot.closest('.collection-grid-section');
    if (!section) return;

    var widgetPresent = function () {
      return !!section.querySelector(RECO_SELECTOR);
    };
    if (widgetPresent()) return;

    if (window.Shopify && Shopify.designMode) {
      slot.style.display = 'none';
      return;
    }

    var stop = function () {
      observer.disconnect();
      clearTimeout(timer);
    };
    var observer = new MutationObserver(function () {
      if (widgetPresent()) stop();
    });
    observer.observe(section, { childList: true });

    var timer = setTimeout(function () {
      stop();
      if (!widgetPresent()) slot.style.display = 'none';
    }, TIMEOUT_MS);
  }

  var slots = document.querySelectorAll('.reco-space-reserve');
  for (var i = 0; i < slots.length; i++) manage(slots[i]);
})();
